import * as _ from 'underscore';

import { ISchedule } from '../../schedule/types/ISchedule';
import { IExtractTaskInfo } from '../models/IExtractTaskInfo';
import { ExtractTaskTargetType, IExtractServiceTask, IExtractTask } from '../ServerApi/types/IExtractTask';
import { ISiteNameWithId } from '../ServerApi/types/ISiteNameWithId';
import { INamedItem, IPublishedConnectionWithTablesItem } from '../ServerApi/types/resourceParts';
import { MapperHelper } from './MapperHelper';

export module ExtractTaskMapper {

  const M = MapperHelper;

  export function map(
    dcs: IExtractTask[],
    schedule: _.Dictionary<ISchedule>,
    site: _.Dictionary<ISiteNameWithId>,
    workbooks: _.Dictionary<INamedItem>,
    datasources: _.Dictionary<INamedItem>,
    publishedConnections: _.Dictionary<IPublishedConnectionWithTablesItem>,
    extractServiceTasks?: _.Dictionary<IExtractServiceTask>
  ): IExtractTaskInfo[] {

    return _.map(dcs, (et: IExtractTask) => {

      const targetWorkbook = et.targetType === ExtractTaskTargetType.Workbook ? workbooks[et.targetId] : undefined;
      const targetDatasource = et.targetType === ExtractTaskTargetType.Datasource ? datasources[et.targetId] : undefined;
      const targetPublishedConnection = et.targetType === ExtractTaskTargetType.PublishedConnection ? publishedConnections[et.targetId] : undefined;

      return {
        id:          et.id,
        contentType: 'extractTask',
        priority:    et.priority,
        type:        et.type,
        lastRunAt:   M.toDate(et.lastRunAt),
        runNextAt:   M.toDate(et.runNextAt),
        schedule:    schedule[et.scheduleId],
        site:        site[et.siteId],
        workbook:    targetWorkbook,
        datasource:  targetDatasource,
        publishedConnection: targetPublishedConnection,
        extractServiceTask: extractServiceTasks[et.id],
        state:       et.state,
      };
    });
  }

}
